/****************************************************
 * Module Name:  addMemostatusModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import MemostatusProxy from "../../utility/proxy/manager/memostatusProxy";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import Utility from "../../utility/utility";
import { Box, Button, TextField } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddMemostatusModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newstatus: this.props.editOperation ? this.props.sourceData.status : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validateMemostatusPresentSpinner: false,
      showValidationMessage: false,
      memostatusAvailable: true,

      statusValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      status: this.state.newstatus,
      description: this.state.newdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateMemostatusPresent = (memostatusEntered) => {
    if (!memostatusEntered || memostatusEntered.trim() === "") return;

    this.setState({
      validateMemostatusPresentSpinner: true,
    });

    MemostatusProxy.CheckMemostatusAvailable(memostatusEntered, (response) => {
      //if we got response that means memostatus is present at backend
      if (response) {
        //Memo Status already present
        this.setState({
          validateMemostatusPresentSpinner: false,
          showValidationMessage: true,
          memostatusAvailable: false,
        });
      } else {
        //Memo Status not available, so can be used
        this.setState({
          validateMemostatusPresentSpinner: false,
          showValidationMessage: true,
          memostatusAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage || !this.state.memostatusAvailable
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add memo status validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Memo Status"
                : "Add New Memo Status"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Memo Status Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Memo Status <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newstatus}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Memo status  (required)"
                          placeholder="Enter Memo status"
                          value={this.state.newstatus}
                          autoFocus
                          onBlur={(e) =>
                            this.validateMemostatusPresent(this.state.newstatus)
                          }
                          onChange={(e) =>
                            this.setState({
                              newstatus: e.target.value,
                              showValidationMessage: false,
                              statusValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Memo Status Cannot be Empty",
                            })
                          }
                          helperText={this.state.statusValidationError}
                          error={this.state.statusValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateMemostatusPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.memostatusAvailable ? (
                        <font color="green">Memo Status available</font>
                      ) : (
                        <font color="red">Memo Status not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
